import React, { useState } from 'react';
import { Box, Button, Grid, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CommonTable from 'components/commonTable/CommonTable';
import CommonDialog from 'components/commonDialog/CommonDialog';
import Loader from 'components/loader/Loader';
import CommonButton from 'components/commonButton/CommonButton';

export default function TabAddCompliance(props) {

  const {tableData,
    onCheckChange,
    handleChangePage,
    handleChangeRowsPerPage,
    page,
    rowsPerPage,
    loader,
    onClickMoreIcon,
    moreIconData,
    viewMoreIcon,
    addAccess,
    formData} = props;

  const [value, setValue] = useState('subVendor');
  const [open, setOpen] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    props.handleChange(newValue);
  };

  const handleOpenAddCompliance = () => {
    setOpen(true);
  };

  const onDialog = (data, code) => {
    props.onSubmittBtn(data, code);
    setOpen(false);
  };

  return (
    <Grid container>
      <Grid item className="tabContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                  className='minHeight32'
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                  }}
                >
                  <Tab
                    label="Sub-Vendor "
                    value="subVendor"
                    className="tabStyle"
                  />
                  <Tab label="Driver" value="driver" className="tabStyle" />
                  <Tab label="Vehicle" value="vehicle" className="tabStyle" />
                </TabList>
              </Grid>

              <Grid item className="">
                <CommonButton
                name={addAccess && 'Add Compliance +'}
                btnClass={'btnMedium btnYellow'}
                iconPlace="back"
                onClick={() => {
                  handleOpenAddCompliance();
                }}
              />
              </Grid>
            </Grid>
            <TabPanel
              value="vendor"
              className="vendotTable tabPanelStyle"
              sx={{ width: '100%' }}
            >
              {loader ? <Loader /> :
              <CommonTable data={tableData}
              onCheckChange={onCheckChange}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
              loader={loader}
              onClickMoreIcon={onClickMoreIcon}
              moreIconData={moreIconData}
              tabName="compliance"
              viewMoreIcon={viewMoreIcon}
              />}
            </TabPanel>
            <TabPanel value="subVendor" className="vendotTable tabPanelStyle">
              {loader ? <Loader /> : <CommonTable data={tableData}
              onCheckChange={onCheckChange}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
              loader={loader}
              onClickMoreIcon={onClickMoreIcon}
              tabName="compliance"
              tableOnClickRow={() => {}}
              viewMoreIcon={viewMoreIcon}
              />}
            </TabPanel>
            <TabPanel value="driver" className="vendotTable tabPanelStyle">
              {loader ? <Loader /> : <CommonTable data={tableData}
              onCheckChange={onCheckChange}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
              loader={loader}
              onClickMoreIcon={onClickMoreIcon}
              moreIconData={moreIconData}
              tableOnClickRow={() => {}}
              tabName="compliance"
              viewMoreIcon={viewMoreIcon}
              />}
            </TabPanel>
            <TabPanel value="vehicle" className="vendotTable tabPanelStyle">
              {loader ? <Loader /> : <CommonTable data={tableData}
              onCheckChange={onCheckChange}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
              loader={loader}
              onClickMoreIcon={onClickMoreIcon}
              moreIconData={moreIconData}
              tableOnClickRow={() => {}}
              tabName="compliance"
              viewMoreIcon={viewMoreIcon}
              />}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
      {open ? (
        <CommonDialog
          className="marginbottom20"
          open={open}
          handleClose={() => setOpen(false)}
          formData={formData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={'Create'}
          type={'Compliance'}
        />
      ) : null}
    </Grid>
  );
}
